<div class="textarea-container">
    <textarea #input class="ag-large-text-input" [(ngModel)]="value" rows="5" [placeholder]="placeholder" [maxlength]="maxLength" (focusin)="showTooltip = true" (focusout)="showTooltip = false"
    [style.width.px]="cellWidth"></textarea>
    <mat-icon *ngIf="value?.length > 0" class="clear-icon" (click)="clearValue($event)" (keydown.enter)="clearValue($event)" tabindex="0" aria-label="Clear input">close</mat-icon>
    <div class="tooltip" *ngIf="showTooltip && value?.length > 0">
        <div class="tooltip-content">
            Max Characters: {{value?.length || 0}}/{{maxLength}}
            <img class="error-icon" src="/images/notification2.svg" alt="error" />
        </div>
        <div class="tooltip-pointer"></div>
    </div>
</div>
